module.exports = __webpack_public_path__ + "assets/3089c455c2a13fdb17e258b4abe1752b.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/timice/Desktop/ROC2/engine/public-src/spingames/panel/sounds/buttons/coins/bet_3.mp3
 ** module id = 40
 ** module chunks = 0
 **/